





























import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';

@Component({
  components: {
  },
})

export default class Modal extends Vue {
  @Prop() private isDataSchema!: boolean;
  @Prop({default: false}) private loading!: boolean;

  public close() {
    this.$emit('close', true);
  }
}
